import React from 'react';
import PropTypes from 'prop-types';
import ConnectedReviewForm from './ConnectedReviewForm';

const ReviewRouting = () => <ConnectedReviewForm />;

ReviewRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ReviewRouting;
